// extracted by mini-css-extract-plugin
export var container = "_6t-0";
export var infoButton = "_6t-1";
export var label = "_6t-3";
export var labelExpanded = "_6t-4";
export var price = "_6t-5";
export var priceExpanded = "_6t-6";
export var title = "_6t-2";